import axios from "axios";
import router from "../../router";
// initial state
const state = {
  user_type: localStorage.getItem("user-type") || "",
  token: localStorage.getItem("user-token") || "",
  expiration_time: localStorage.getItem('exp-time') || '',
  status: "",
  fullPath_email: null
};

// getters
const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  userType: state => state.user_type,
  expirationTime: state => state.expiration_time,
  routePath_email: state => state.fullPath_email
};

// actions
const actions = {
  registration({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/registration",
        data: user,
        method: "POST"
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err.response.data);
        });
    });
  },
  //confirm-email?token=
  registrationConfirm({ commit }, token) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/registration/confirm/" + token,
        data: {},
        method: "POST"
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  auth({ commit, rootState }, user) {
    commit("authRequest");
    return new Promise((resolve, reject) => {
      axios({
        url: "/auth",
        data: user,
        method: "POST"
      })
        .then(res => {
          const token = res.data.payload.token;
          const user_type = res.data.payload.user_type;
          const expiration_time = res.data.payload.exp;
          localStorage.setItem("user-token", token);
          localStorage.setItem("user-type", user_type);
          localStorage.setItem("exp-time", expiration_time);
          axios.defaults.headers.common["X-Auth-Token"] = token;
          commit("authSuccess", { token: token, user_type: user_type, exp_time: expiration_time });
          resolve(res);
        })
        .catch(error => {
          commit("authError", error);
          localStorage.removeItem("user-token");
          localStorage.removeItem("user-type");
          reject(error);
        });
    });
  },
  verifyToken({ commit, dispatch, rootState }) {
    axios({
      url: "/auth/check-token",
      method: "POST"
    }).catch(error => {
      commit("authError", error);
      dispatch("logout").then(() => {
        router.push({ name: "login" });
      });
    });
  },
  logout: ({ commit }) => {
    return new Promise(resolve => {
      localStorage.removeItem("user-token");
      localStorage.removeItem("user-type");
      localStorage.removeItem("exp-time");
      localStorage.removeItem("user");
      router.push({ name: "login" });
      commit("authLogout");
      resolve();
    });
  },
  forgotPassword({ commit }, email) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/auth/reset_email",
        data: { email: email },
        method: "POST"
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //reset-password?token=
  resetConfirmation({ commit }, reset) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/auth/reset_password/" + reset.token,
        data: { passwd: reset.passwd },
        method: "POST"
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postUser({ commit, rootState }, user) {
    axios({
      url: "/user",
      data: user,
      method: "POST"
    })
      .then(() => { })
      .catch(error => {
        commit("catchError", error);
      });
  },
  deleteUser({ commit, rootState }, user_uuid) {
    axios({
      url: "/user/" + user_uuid,
      method: "DELETE"
    })
      .then(() => { })
      .catch(error => {
        commit("catchError", error);
      });
  },
  getUser({ commit, rootState }, user_uuid) {
    axios({
      url: "/user/" + user_uuid,
      method: "GET"
    })
      .then(() => { })
      .catch(error => {
        commit("catchError", error);
      });
  },
  patchUser({ commit, rootState }, user) {
    axios({
      url: "/user/" + user.uuid,
      data: user.data,
      method: "PATCH"
    })
      .then(() => { })
      .catch(error => {
        commit("catchError", error);
      });
  },
  getUserList({ commit, rootState }, page) {
    return new Promise(resolve => {
      axios({
        url: "/user/list?page=" + page,
        method: "GET"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(error => {
          commit("catchError", error);
        });
    });
  }
};

// mutations
const mutations = {
  setRoutePath: (state, payload) => {
    state.fullPath_email = payload;
  },
  authRequest: state => {
    state.status = "loading";
  },
  authSuccess: (state, response) => {
    state.status = "success";
    state.token = response.token;
    state.user_type = response.user_type;
    state.expiration_time = response.exp_time;
  },
  authError: state => {
    state.status = "error";
  },
  authLogout: state => {
    state.user_type = "";
    state.token = "";
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
